import { useEffect, useRef, useState } from 'react';

import { useOnlineStatus } from './useOnlineStatus';
import styles from './OfflineBanner.module.css';

export function OfflineBanner() {
  const { isOffline } = useOnlineStatus();
  const [dismissed, setDismissed] = useState(false);
  const wasOffline = useRef(isOffline);

  useEffect(() => {
    if (isOffline && !wasOffline.current) {
      setDismissed(false);
    }

    wasOffline.current = isOffline;
  }, [isOffline]);

  if (!isOffline || dismissed) {
    return null;
  }

  return (
    <div aria-live="polite" className={styles.banner} role="status">
      <p className={styles.message}>
        You&apos;re offline. Changes will sync when reconnected.
      </p>
      <button
        className={styles.dismiss}
        onClick={() => setDismissed(true)}
        type="button"
      >
        Dismiss
      </button>
    </div>
  );
}

